// Centralized API configuration for Vite
// This replaces import.meta.env.VITE_API_URL with import.meta.env.VITE_API_URL

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1/'

// Ensure URL ends with trailing slash
export const getApiUrl = () => {
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1/'
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
}

export default API_URL
